import { render, staticRenderFns } from "./mainButtonMin.vue?vue&type=template&id=33c905a8&scoped=true&"
import script from "./mainButtonMin.vue?vue&type=script&lang=js&"
export * from "./mainButtonMin.vue?vue&type=script&lang=js&"
import style0 from "./mainButtonMin.vue?vue&type=style&index=0&id=33c905a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33c905a8",
  null
  
)

export default component.exports